<template>
  <div>
    <HeaderReceipt header="เพิ่มสินค้าเข้าคลังจากใบเสร็จ" :img_header="header_image" link_back="stock/storage/addproducttostock"/>
    <StoragePR/>
  </div>
</template>

<script>
import HeaderImage from '@/assets/verified.png'
import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt.vue";
import StoragePR from "@/components/admin/stock/pr/StoragePR.vue";
export default {
  name: "PrReceipt",
  components: {
    StoragePR,
    HeaderReceipt
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
